import Spinner from 'components/spinner/spinner.component';
import * as S from './locations-card-spinner.styles';

const LocationsCardSpinner = () => (
  <S.Container>
    <Spinner fade={false} />
  </S.Container>
);
export default LocationsCardSpinner;
